export default __webpack_public_path__ + "static/media/Tron.5caa7d36.svg";